module.exports = __webpack_public_path__ + "static/media/qr_code_scanner_enabled.cf7311a3.svg";